export async function getChoiceGroupsPricing({
  locale,
  vatInc,
  productOptionsHash,
  pricingResponse,
  quantity,
  hideShippingMessageInVatMessage,
  hideVatMessage = false,
}: Gallery.Pricing.ChoiceGroupsPricingType): Promise<Gallery.Pricing.FormattedPrices | null> {
  if (!pricingResponse || !pricingResponse.choiceGroups) {
    throw new Error(`Unable to call getChoiceGroupsPricing. pricingResponse is required`)
  }

  const result = Object.entries(pricingResponse.choiceGroups).reduce((acc: Gallery.Pricing.FormattedPrices | null, [key, entry]) => {
    if (key !== productOptionsHash.toString()) return acc

    const { priceCalculationFailed, failureReason, totalListPrice, totalDiscountPrice, unitListPrice, unitDiscountedPrice } = entry

    if (priceCalculationFailed) {
      throw new ReferenceError(`Price calculation failed: ${failureReason}`)
    }

    if (!totalListPrice || !totalDiscountPrice || !unitListPrice || !unitDiscountedPrice) {
      throw new ReferenceError(`Missing price data for product ${key}`)
    }

    return {
      locale,
      quantity,
      hideVatMessage,
      totalListPrice,
      totalDiscountedPrice: totalDiscountPrice,
      unitListPrice,
      unitDiscountedPrice,
      currency: pricingResponse.currency,
      minimumFractionDigits: pricingResponse.fractionDigits,
      vatInc,
      hideShippingMessageInVatMessage: hideShippingMessageInVatMessage || false,
    }
  }, null)

  return result
}
